/* istanbul ignore file */
import React from 'react';
import { sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
import {
  type BreadcrumbLinkClickPayload,
  Breadcrumbs,
} from '@noths/polaris-design-system-candidate-components';

import { buildBreadcrumbClickEvent } from './breadcrumbClickEvent';
import type { BreadcrumbsContainerStateProps } from './types';

export const BreadcrumbsContainer = ({
  breadcrumbsLinks,
  includesCurrentPage = true,
}: BreadcrumbsContainerStateProps) => {
  const onLinkClick = (
    e: React.MouseEvent | React.MouseEvent<HTMLAnchorElement>,
    { linkDepth }: BreadcrumbLinkClickPayload,
  ) => {
    return sendGALinkClickEvent(
      e,
      buildBreadcrumbClickEvent({
        destinationURL: (e.currentTarget as HTMLAnchorElement).href,
        linkDepth,
      }),
    );
  };

  return (
    <Breadcrumbs
      includesCurrentPage={includesCurrentPage}
      links={breadcrumbsLinks}
      onLinkClick={onLinkClick}
    />
  );
};
